import {
	CANCEL_OUTSIDE_CLICK_CHANGED,
	LANGUAGE_HAS_BEEN_CHANGED,
	SET_TOOLTIP,
} from './actionTypes';

const INITIAL_STATE = {
	language: 'pt-BR',
	cancelOutsideClick: false,
	tooltip: {
		display: false,
		title: '',
		type: 'info',
		translate: true,
	},
};

export function globalReducer(state: any = { ...INITIAL_STATE }, action: any) {
	switch (action.type) {
		case LANGUAGE_HAS_BEEN_CHANGED:
			return { ...state, language: action.payload };
		case CANCEL_OUTSIDE_CLICK_CHANGED:
			return { ...state, cancelOutsideClick: action.payload };
		case SET_TOOLTIP:
			return { ...state, tooltip: { ...state.tooltip, ...action.payload } };
		default:
			return state;
	}
}
